/* eslint-disable max-len */
import cdnSrc from '../../utils/cdnSrc';
import { OV_EMS_CDN } from '../../config/theme';
var FABRIC = 'CloudKnit';
var DEFAULT_ALT = "Outdoor Voices - ".concat(FABRIC);
var imgRoot = 'images/pages/cloudknit/';
var hero = {
  cta: {
    href: '/collections/cloudknit',
    text: 'Shop Now',
    white: true
  },
  imageDesktop: {
    alt: DEFAULT_ALT,
    src: "".concat(OV_EMS_CDN, "media/pages/hero-desktop.jpg"),
    width: 2400
  },
  imageMobile: {
    src: cdnSrc("".concat(imgRoot, "heros/hero-mobile.jpg")),
    alt: DEFAULT_ALT
  },
  title: FABRIC
};
var subHero = {
  cta: {
    href: '/collections/cloudknit',
    text: 'Shop CloudKnit'
  },
  description: 'Lightweight, stretchy, and just about the softest thing in your closet. No clouds were harmed in the making of these insanely soft hoodies, tees, and pants.',
  image: {
    src: cdnSrc("".concat(imgRoot, "heros/subhero-desktop.jpg")),
    alt: 'OV CloudKnit'
  },
  imageMobile: {
    src: cdnSrc("".concat(imgRoot, "heros/subhero-mobile.jpg")),
    alt: 'OV CloudKnit'
  },
  title: 'Soft Is an Understatement'
};
var footerHero = {
  fabric: FABRIC,
  cta: {
    href: '/collections/cloudknit',
    text: 'Shop CloudKnit'
  },
  image: {
    src: cdnSrc("".concat(imgRoot, "heros/footer-desktop.jpg")),
    alt: DEFAULT_ALT
  },
  imageMobile: {
    src: cdnSrc("".concat(imgRoot, "heros/footer-mobile.jpg")),
    alt: DEFAULT_ALT
  },
  messages: ['puppies', 'kittens', 'clouds']
};
var productItemsWomen = [{
  cta: 'Shop All Day Hoodie',
  fabric: FABRIC,
  features: ['Adjustable drawstring hoodie', 'Cozy kangaroo pocket', 'Thumbholes keep your hands warm', 'Made in our signature CloudKnit fabric'],
  id: 'hoodie-w',
  image: cdnSrc("".concat(imgRoot, "flats/hoodie-green-w.jpg")),
  title: 'Hoodie',
  url: '/products/w-cloudknit-hoodie?variant=30266863583310'
}, {
  cta: 'Shop All Day Sweatpant',
  fabric: FABRIC,
  features: ['Roomy pockets', 'Drawstring waistband', 'Made in our signature CloudKnit fabric'],
  id: 'sweatpants-w',
  image: cdnSrc("".concat(imgRoot, "flats/pants-grey-w.jpg")),
  title: 'Sweatpant',
  url: '/products/w-cloudknit-sweats?variant=1183163678725'
}, {
  cta: 'Shop All Day Shortsleeve',
  fabric: FABRIC,
  features: ['Classic fit', 'Easily layerable', 'Made in our signature CloudKnit fabric'],
  id: 't-shirt-w',
  image: cdnSrc("".concat(imgRoot, "flats/tshirt-navy-w.jpg")),
  title: 'Shortsleeve',
  url: '/products/w-cloudknit-shortsleeve?variant=26467525957'
}, {
  cta: 'Shop All Day Longsleeve',
  fabric: FABRIC,
  features: ['Thumbholes keep your hands warm', 'Made in our signature CloudKnit fabric'],
  id: 'longsleeve-w',
  image: cdnSrc("".concat(imgRoot, "flats/longsleeve-green-w.jpg")),
  title: 'Longsleeve',
  url: '/products/cloudknit-longsleeve?variant=30259882786894'
}];
var productItemsMen = [{
  cta: 'Shop All Day Hoodie',
  fabric: FABRIC,
  features: ['Cozy kangaroo pocket', 'Made in our signature CloudKnit fabric'],
  id: 'hoodie-m',
  image: cdnSrc("".concat(imgRoot, "flats/hoodie-charcoal-m.jpg")),
  title: 'Hoodie',
  url: '/products/m-cloudknit-hoodie?variant=24105606341'
}, {
  cta: 'Shop All Day Sweatpant',
  fabric: FABRIC,
  features: ['Roomy pockets', 'Drawstring waistband', 'Made in our signature CloudKnit fabric'],
  id: 'sweatpants-m',
  image: cdnSrc("".concat(imgRoot, "flats/pants-navy-m.jpg")),
  title: 'Sweatpant',
  url: '/products/m-cloudknit-sweats?variant=25239063749'
}, {
  cta: 'Shop All Day Shortsleeve',
  fabric: FABRIC,
  features: ['Classic fit', 'Easily layerable', 'Made in our signature CloudKnit fabric'],
  id: 't-shirt-m',
  image: cdnSrc("".concat(imgRoot, "flats/tshirt-grey-m.jpg")),
  title: 'Shortsleeve',
  url: '/products/m-cloudknit-tee?variant=17541790629966'
}];
var quotes = [{
  cta: {
    text: 'Shop All Day Sweatpant',
    href: '/products/w-cloudknit-sweats?variant=1183163678725'
  },
  fabric: FABRIC,
  id: 'feature-sweatpants',
  image: {
    src: cdnSrc("".concat(imgRoot, "quotes/quote1-desktop.jpg")),
    alt: 'OV CloudKnit Sweatpants'
  },
  imageMobile: {
    src: cdnSrc("".concat(imgRoot, "quotes/fabric-navy-mobile.jpg")),
    alt: 'OV CloudKnit Fabric - Navy',
    darkFont: false
  },
  rating: 5,
  quote: "\"They are the best sweatpants ever created \u2014 it's like you're wearing clouds for pants.\"",
  quoter: 'Reilly'
}, {
  cta: {
    text: 'Shop All Day Hoodie',
    href: '/products/m-cloudknit-hoodie?variant=24105606341'
  },
  fabric: 'CloudKnit',
  id: 'feature-cloudknit-tshirt',
  image: {
    src: cdnSrc("".concat(imgRoot, "quotes/quote2-desktop.jpg")),
    alt: 'OV CloudKnit T-Shirt'
  },
  imageMobile: {
    src: cdnSrc("".concat(imgRoot, "quotes/fabric-charcoal-mobile.jpg")),
    alt: 'OV CloudKnit Fabric - Charcoal',
    darkFont: false
  },
  rating: 5,
  quote: "\"Buy this if you want the most comfortable hoodie you've ever owned.\"",
  quoter: 'David'
}, {
  cta: {
    text: 'Shop All Day Hoodie',
    href: '/products/w-cloudknit-hoodie?variant=18318765765'
  },
  fabric: 'CloudKnit',
  id: 'feature-cloudknit-tshirt',
  image: {
    src: cdnSrc("".concat(imgRoot, "quotes/quote3-desktop.jpg")),
    alt: 'OV CloudKnit T-Shirt'
  },
  imageMobile: {
    src: cdnSrc("".concat(imgRoot, "quotes/fabric-fog-mobile.jpg")),
    alt: 'OV CloudKnit Fabric - Fog',
    darkFont: true
  },
  rating: 5,
  quote: '"Do yourself a favor: Throw out all your old ugly joggers, buy these, and then never take them off."',
  quoter: 'Madison'
}];
var ugcs = [{
  hoverText: '@alexisbadiyi and her family cozy up in their CloudKnit sets.',
  image: {
    alt: '@alexisbadiyi Instagram - family time, sporting OV CloudKnit longsleeves and sweatpants.',
    src: cdnSrc("".concat(imgRoot, "ugcs/@alexisbadiyi_1x1.jpg"))
  }
}, {
  hoverText: 'CloudKnit, but make it fashion. @lovefola',
  image: {
    alt: '@lovefola Instagram - @youngluther shows off our Fog-color sweatpants, fresh off the subway.',
    src: cdnSrc("".concat(imgRoot, "ugcs/@lovefola.jpg"))
  }
}, {
  hoverText: '@youngluther warms up for pickup in CloudKnit.',
  image: {
    alt: '@youngluther Instagram - juggling a soccer ball in his matching CloudKnit Hoodie and Sweatpants in Heather Grey',
    src: cdnSrc("".concat(imgRoot, "ugcs/@youngluther.jpg"))
  }
}, {
  hoverText: '@themjeans trying to figure out which cuddles are softer, puppies or CloudKnit?',
  image: {
    alt: '@themjeans Instagram - relaxing with his puppydog, @madge_music keeps it easy at home in his CloudKnit T-Shirt.',
    src: cdnSrc("".concat(imgRoot, "ugcs/@themjeans.jpg"))
  }
}, {
  hoverText: 'CloudKnit: the perfect uniform for even the chillest of activities. Just ask @madge_music.',
  image: {
    alt: '@madge_music Instagram - lounging on her couch and a good magazine, @madge_music is decked out our Hunter Green CloudKnit Hoodie and Sweatpants.',
    src: cdnSrc("".concat(imgRoot, "ugcs/@madge_music.jpg"))
  }
}, {
  hoverText: 'The base layer you will never want to take off. @hellokbello',
  image: {
    alt: '@hellokbello Instagram - Layered up, @hellokbello shows off her trendy style by layering our Cloudnit Hoodie in Fog underneath a stylish black-leather jacket.',
    src: cdnSrc("".concat(imgRoot, "ugcs/@hellokbello.jpg"))
  }
}];
var props = {
  fabric: FABRIC,
  fabricProductCategories: 'All Day',
  features: quotes,
  footerHero: footerHero,
  hero: hero,
  productItemsMen: productItemsMen,
  productItemsWomen: productItemsWomen,
  productItemsTitle: 'Explore CloudKnit',
  productItemsDescription: 'CloudKnit. Cloud Pants. The Softest-Stuff-You-Have-Ever-Worn. No matter what you call our CloudKnit Collection, weï¿½ve got it in every cozy style and color youï¿½re looking for.',
  subHero: subHero,
  ugcs: ugcs,
  ugcsTitle: 'CloudKnit in Action'
};
export default props;